var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 8.66697C6.95305 9.04972 7.31832 9.36642 7.73778 9.5956C8.15724 9.82477 8.62109 9.96105 9.09785 9.99519C9.57461 10.0293 10.0531 9.96055 10.501 9.79349C10.9488 9.62643 11.3555 9.36502 11.6934 9.02697L13.6934 7.02697C14.3006 6.3983 14.6366 5.55629 14.629 4.6823C14.6214 3.80831 14.2708 2.97227 13.6528 2.35424C13.0348 1.73621 12.1987 1.38565 11.3248 1.37806C10.4508 1.37046 9.60876 1.70644 8.98008 2.31364L7.83341 3.45364",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33322 7.33381C9.04692 6.95106 8.68165 6.63435 8.26219 6.40518C7.84273 6.17601 7.37888 6.03973 6.90212 6.00559C6.42536 5.97144 5.94683 6.04023 5.49899 6.20729C5.05115 6.37435 4.64448 6.63576 4.30656 6.97381L2.30656 8.97381C1.69936 9.60248 1.36338 10.4445 1.37098 11.3185C1.37857 12.1925 1.72913 13.0285 2.34716 13.6465C2.96519 14.2646 3.80123 14.6151 4.67522 14.6227C5.54921 14.6303 6.39121 14.2943 7.01989 13.6871L8.15989 12.5471",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a2c77004aa0c0e59a019451b11f715c6.svg";
export { ForwardRef as ReactComponent };